<template>
  <div class="cml-wrap">
    <div class="cml-card">
      <div class="cml-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10"/>
          <line x1="12" y1="8" x2="12" y2="12"/>
          <line x1="12" y1="16" x2="12.01" y2="16"/>
        </svg>
      </div>
      <div class="cml-title">Use your password to log in</div>
      <div class="cml-sub">
        This link is no longer active. Please sign in using the password you set when you registered.
      </div>
      <a href="/login" class="cml-btn">Go to Login →</a>
      <a href="/forgotpassword" class="cml-forgot">Forgot your password? Reset it here</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClientMagicLogin',
};
</script>

<style scoped>
.cml-wrap {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%);
  font-family: 'Plus Jakarta Sans', system-ui, sans-serif;
}
.cml-card {
  background: #fff;
  border-radius: 20px;
  padding: 48px 40px 40px;
  text-align: center;
  box-shadow: 0 8px 40px rgba(59, 76, 192, 0.10);
  max-width: 420px;
  width: 90%;
}
.cml-icon {
  width: 72px; height: 72px; border-radius: 50%;
  background: #EEF0FD; display: flex; align-items: center;
  justify-content: center; margin: 0 auto 24px;
}
.cml-icon svg { width: 32px; height: 32px; color: #3B4CC0; }
.cml-title { font-size: 1.25rem; font-weight: 700; color: #1E1E2F; margin-bottom: 8px; }
.cml-sub   { font-size: 0.875rem; color: #9A96A8; margin-bottom: 24px; line-height: 1.6; }
.cml-btn {
  display: inline-block;
  background: #3B4CC0;
  color: #fff;
  font-size: 0.9rem;
  font-weight: 600;
  padding: 12px 28px;
  border-radius: 10px;
  text-decoration: none;
  margin-bottom: 16px;
}
.cml-btn:hover { background: #2e3da0; }
.cml-forgot {
  display: block;
  font-size: 0.82rem;
  color: #3B4CC0;
  text-decoration: none;
  margin-top: 4px;
}
.cml-forgot:hover { text-decoration: underline; }
</style>
